/*
  © 2025 Jhango
  https://www.jhango.com
*/

class Navbar extends HTMLElement {
  constructor() {
    super();

    this.handleDropdownsBackdrop();
    this.handleHeaderReveal();
    this.adjustOffcanvasMenu();
  }

  adjustOffcanvasMenu() {
    const offcanvasMenu = document.querySelector("#offcanvas-menu");
    const navbarMobile = document.querySelector("#navbar-mobile");

    offcanvasMenu?.addEventListener("show.bs.offcanvas", () => {
      const navbarSpacing = document
        .querySelector("#navbar-mobile")
        .getBoundingClientRect().bottom;
      offcanvasMenu.style.height = `${window.innerHeight - navbarSpacing}px`;

      navbarMobile
        .querySelector(".svg-icon-menu")
        ?.classList.add("svg-icon-menu-close");

      this.insertAdjacentHTML(
        "beforeBegin",
        `
        <style>
          #offcanvas-menu + .offcanvas-backdrop {
            top: ${navbarSpacing}px
          }
        </style>
      `
      );
    });

    offcanvasMenu?.addEventListener("hide.bs.offcanvas", () => {
      navbarMobile
        .querySelector(".svg-icon-menu")
        ?.classList.remove("svg-icon-menu-close");
    });
  }

  handleHeaderReveal() {
    let oldScroll = window.scrollY;
    const headerGroup = document.querySelector("#header-group");

    window.addEventListener("scroll", () => {
      const newScroll = window.scrollY;
      if (newScroll > oldScroll) {
        if (newScroll > headerGroup.clientHeight) {
          headerGroup.classList.add("hide");
        }
      } else if (newScroll < oldScroll) {
        headerGroup.classList.remove("hide");
      }

      oldScroll = Math.max(window.scrollY, 0);
    });
  }

  handleDropdownsBackdrop() {
    this.querySelectorAll("#navbar-desktop .dropdown-toggle").forEach(
      (dropdown) => {
        dropdown.addEventListener("hidden.bs.dropdown", () => {
          if (
            !document.querySelector("#navbar-desktop .dropdown-toggle.show")
          ) {
            document.body.classList.remove("navbar-dropdown-open");
          }
        });
        dropdown.addEventListener("show.bs.dropdown", () => {
          document.body.classList.add("navbar-dropdown-open");
        });
      }
    );
  }
}
customElements.define("navbar-wrapper", Navbar);

class HeroCarousel extends HTMLElement {
  constructor() {
    super();

    this.animateOnScroll();
  }

  animateOnScroll() {
    window.addEventListener("scroll", () => {
      const windowHeight = window.innerHeight;
      const sectionHeight = this.clientHeight;

      const top = Math.round(this.getBoundingClientRect().top);
      const bottom = Math.round(this.getBoundingClientRect().bottom);
      const visibilityTop = Math.round(
        ((windowHeight - top) / sectionHeight) * 100
      );
      const visibilityBottom = Math.round((bottom / sectionHeight) * 100);

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll(".media-wrapper").forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const final = Math.round(
            (100 - overlayOpacity) * (1 - visibilityTop / 100) + overlayOpacity
          );
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll(".media-wrapper").forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const final = Math.round(
            (100 - overlayOpacity) * (1 - visibilityBottom / 100) +
              overlayOpacity
          );
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      }
    });
  }
}
customElements.define("hero-carousel", HeroCarousel);

class StickyMedia extends HTMLElement {
  constructor() {
    super();

    this.animateOnScroll();
  }

  animateOnScroll() {
    window.addEventListener("scroll", () => {
      const windowHeight = window.innerHeight;

      const top = this.getBoundingClientRect().top;
      const bottom = this.getBoundingClientRect().bottom;
      const visibilityTop = Math.round((top / windowHeight) * 100);
      const visibilityBottom = Math.round((bottom / windowHeight) * 100);

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll(".media-wrapper").forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const final = Math.round(
            ((100 - overlayOpacity) * visibilityTop) / 100 + overlayOpacity
          );
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll(".media-wrapper").forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const final = Math.round(
            (100 - overlayOpacity) * (1 - visibilityBottom / 100) +
              overlayOpacity
          );
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      }
    });
  }
}
customElements.define("sticky-media", StickyMedia);

class Marquee extends HTMLElement {
  constructor() {
    super();

    this.init();

    document.addEventListener("shopify:section:load", (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init();
      }
    });
  }

  init() {
    const list = this.querySelector(".marquee-list");
    list
      .querySelectorAll('.marquee-item[aria-hidden="true"]')
      .forEach((elem) => elem.remove());

    const marqueeWidth = list.scrollWidth;
    const marqueeLength = list.querySelectorAll("li").length;

    list.insertAdjacentHTML("beforeEnd", list.innerHTML);
    list.insertAdjacentHTML("beforeEnd", list.innerHTML);

    list.querySelectorAll(".marquee-item").forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute("aria-hidden", "true");
      }
    });

    let style = `
      <style>
        #marquee-${this.dataset.marqueeId} .marquee-list {
          animation-name: marquee_animation_${this.dataset.marqueeId};
          animation-duration: ${this.dataset.marqueeDuration}s;
        }
        @keyframes marquee_animation_${this.dataset.marqueeId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `;
    if (this.dataset.marqueeDirection === "right") {
      style += `
        <style>
          @keyframes marquee_animation_${this.dataset.marqueeId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `;
    }

    this.insertAdjacentHTML("beforeBegin", style);
  }
}
customElements.define("marquee-container", Marquee);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    if (window.Shopify.designMode) return;

    if (window.location.href.includes("newsletter-popup")) {
      window.bootstrap.Modal.getOrCreateInstance(this).show();
      return;
    }

    if (document.cookie.indexOf("ks-newsletter-popup") > -1) {
      return;
    }

    (async () => {
      await new Promise((resolve) =>
        setTimeout(resolve, Number(this.dataset.configDelay) * 1000)
      );
      window.theme.createCookie(
        "ks-newsletter-popup",
        true,
        Number(this.dataset.configDaysToWait)
      );
      window.bootstrap.Modal.getOrCreateInstance(this).show();
    })();
  }
}
customElements.define("newsletter-popup", NewsletterPopup);

class ParallaxMedia extends HTMLElement {
  constructor() {
    super();

    this.animateOnScroll();

    const script = document.querySelector(
      'script[src*="vendor-simple-parallax"]'
    );
    script.onload = () => {
      this.init();
    };

    document.addEventListener("shopify:section:load", (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init();
      }
    });
  }

  init() {
    // eslint-disable-next-line no-new, new-cap
    new window.simpleParallax(this.querySelectorAll(".parallax-media-media"), {
      orientation: this.dataset.parallaxOrientation,
      scale: Number(this.dataset.parallaxScale),
    });
  }

  animateOnScroll() {
    window.addEventListener("scroll", () => {
      const windowHeight = window.innerHeight;
      const sectionHeight = this.clientHeight;

      const top = Math.round(this.getBoundingClientRect().top);
      const bottom = Math.round(this.getBoundingClientRect().bottom);
      const visibilityTop = Math.round(
        ((windowHeight - top) / sectionHeight) * 100
      );
      const visibilityBottom = Math.round((bottom / sectionHeight) * 100);

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll(".media-wrapper").forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const final = Math.round(
            (100 - overlayOpacity) * (1 - visibilityTop / 100) + overlayOpacity
          );
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll(".media-wrapper").forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const final = Math.round(
            (100 - overlayOpacity) * (1 - visibilityBottom / 100) +
              overlayOpacity
          );
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      }
    });
  }
}
customElements.define("parallax-media", ParallaxMedia);

class MyImageCompare extends HTMLElement {
  constructor() {
    super();

    const script = document.querySelector(
      'script[src*="vendor-image-compare"]'
    );
    script.onload = () => {
      this.init();
    };

    document.addEventListener("shopify:section:load", (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init();
      }
    });
  }

  init() {
    this.querySelectorAll("[data-image-compare]").forEach((elem) => {
      new window.ImageCompare(elem, {
        controlColor: this.dataset.icvControlsColor,
        controlShadow: true,
        addCircle: this.dataset.icvControlsCircle === "true",
        addCircleBlur: true,
        showLabels: this.dataset.icvShowLabels === "true",
        labelOptions: {
          before: this.dataset.icvLabelBefore,
          after: this.dataset.icvLabelAfter,
          onHover: false,
        },
        smoothing: this.dataset.icvSmoothing === "true",
        smoothingAmount: 100,
        hoverStart: this.dataset.icvHoverStart === "true",
        verticalMode: this.dataset.icvVerticalMode === "true",
        startingPoint: Number(this.dataset.icvStartingPoint),
        fluidMode: false,
      }).mount();
    });
  }
}
customElements.define("image-compare", MyImageCompare);

class SimpleCollections extends HTMLElement {
  constructor() {
    super();

    if (window.matchMedia("(max-width: 799px)").matches) {
      setTimeout(() => {
        const left =
          this.querySelector(
            ".simple-collections-item.active"
          )?.getBoundingClientRect().left || 0;
        this.scrollBy({ left, behavior: "smooth" });
      }, 1000);
    }
  }
}
customElements.define("simple-collections", SimpleCollections);

class LookBook extends HTMLElement {
  constructor() {
    super();

    this.points = this.querySelectorAll(".lookbook-point-list button");
    this.mySwiper = this.querySelector(".swiper").swiper;

    this.points.forEach((elem) => {
      elem.addEventListener("click", () => this.onPointerClick(elem));
    });

    this.mySwiper.on("slideChange", () => this.onSlideChange());
  }

  onPointerClick(btn) {
    this.mySwiper.slideTo(Number(btn.dataset.index));
    this.scrollIntoView();
  }

  onSlideChange() {
    const selectedPoint = this.points[this.mySwiper.activeIndex];

    this.points.forEach((elem) => {
      elem.classList.remove("active");
      if (elem.dataset.index !== selectedPoint.dataset.index) {
        window.bootstrap.Tooltip.getOrCreateInstance(elem).hide();
      }
    });

    selectedPoint.classList.add("active");

    if (!selectedPoint.getAttribute("aria-describedby")) {
      window.bootstrap.Tooltip.getOrCreateInstance(selectedPoint).show();
    }
  }
}
customElements.define("look-book", LookBook);

class ShoppableVideos extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll("video").forEach((video) => {
      video.addEventListener("click", () => {
        this.onVideoPlay(video);
      });
    });

    this.querySelectorAll("a[data-quick-view]").forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.openQuickView(link);
      });
    });

    this.querySelector(".swiper").swiper.on("slideChange", () => {
      this.querySelectorAll("video").forEach((video) => {
        if (video.closest(".card").dataset.playing === "true") {
          video.closest(".card").setAttribute("data-playing", "false");
          video.pause();
        }
      });
    });
  }

  onVideoPlay(video) {
    this.querySelectorAll("video").forEach((elem) => {
      if (elem.dataset.index !== video.dataset.index) {
        elem.closest(".card").setAttribute("data-playing", "false");
        elem.pause();
      }
    });

    const card = video.closest(".card");

    if (card.dataset.playing === "true") {
      video.closest(".card").setAttribute("data-playing", "false");
      video.pause();
    } else {
      video.closest(".card").setAttribute("data-playing", "true");
      video.muted = false;
      video.play();
    }
  }

  async openQuickView(link) {
    link.disabled = true;
    link.setAttribute("aria-busy", "true");
    link.querySelector(".icon-wrapper").setAttribute("hidden", "hidden");
    link.querySelector(".spinner-border").removeAttribute("hidden");

    const response = await fetch(link.dataset.productUrl);

    if (response.ok) {
      const text = await response.text();
      const newDoc = new DOMParser().parseFromString(text, "text/html");

      document.querySelector("product-quick-view-modal").showModal(newDoc);
    }

    link.disabled = false;
    link.removeAttribute("aria-busy");
    link.querySelector(".icon-wrapper").removeAttribute("hidden");
    link.querySelector(".spinner-border").setAttribute("hidden", "hidden");
  }
}
customElements.define("shoppable-videos", ShoppableVideos);

class StickyATC extends HTMLElement {
  constructor() {
    super();

    this.init();
    this.listenVariantChange();
  }

  init() {
    const stickyAtc = document.querySelector("#sticky-atc");
    const top =
      document
        .querySelector(".product-main .product-block-atc")
        .getBoundingClientRect().bottom + window.scrollY;

    window.addEventListener("scroll", () => {
      if (window.scrollY > top) {
        stickyAtc.classList.add("show");
        document.body.style.paddingBottom = stickyAtc.clientHeight + "px";
      } else {
        stickyAtc.classList.remove("show");
        document.body.style.paddingBottom = 0;
      }
    });

    this.listenVariantChange();
  }

  listenVariantChange() {
    window.addEventListener("kt.product.variant.change", (event) => {
      const selectedVariant = event.detail;

      this.querySelector('select[name="id"]').value = selectedVariant.id;
      this.querySelector('select[name="id"]').dispatchEvent(
        new CustomEvent("change")
      );
    });
  }
}
customElements.define("sticky-atc", StickyATC);

document.addEventListener('DOMContentLoaded', function() {
  return true;

});
  function validateLicense(url) {
    return true
  }